import React, { useCallback } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { PartnerName } from '@melio/platform-api';
import { SessionConfigProvider } from '@melio/vex-activities';
import { useAuth, usePaymentIdFromUrl } from '@melio/vex-domain';

import { BASE_PATH } from '@/api/consts';
import { ConfigurationProvider } from './ConfigurationProvider.component';

type VexConfigurationProviderProps = {
  partnerName: PartnerName;
};

export const VexConfigurationProvider: React.FC<VexConfigurationProviderProps> = ({ partnerName }) => {
  const paymentIdFromUrl = usePaymentIdFromUrl();
  const navigate = useNavigate();
  const onUnauthorized = useCallback(() => navigate('/expired-session'), [navigate]);

  const { accessToken, setAccessTokens, refreshAccessToken } = useAuth({
    paymentId: paymentIdFromUrl,
    onUnauthorized,
    apiBasePath: BASE_PATH,
  });

  return (
    <ConfigurationProvider
      partnerName={partnerName}
      accessToken={accessToken}
      onTokenExpired={refreshAccessToken}
      disablePermissions
    >
      <SessionConfigProvider setAccessTokens={setAccessTokens}>
        <Outlet />
      </SessionConfigProvider>
    </ConfigurationProvider>
  );
};
